<template>
  <UtteranceControl v-bind="$attrs" :disabled-enter="true" :customText="endText" v-on="$listeners"></UtteranceControl>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { UtteranceControl } from '@/components/resources';

@Component({
  components: {
    UtteranceControl
  }
})
export default class EndControl extends Vue {
  get isPreview () {
    return this.$route.query?.type === 'preview' && this.$route.path.startsWith('/main') && this.$route.params.pathMatch.startsWith('https')
  }

  get endText () {
    return  this.isPreview ? '对话已结束' : '当前课程已结束' 
  }
}
</script>
